import styled from 'styled-components';

export const Container = styled.div<{ $showBigResources: boolean }>`
	overflow-y: auto;
	height: ${props => (props.$showBigResources ? '90px' : '142px')};
	transition-duration: 0.2s;
	width: 100%;
`;

export const Button = styled.button`
	outline: none;
`